import {useState} from 'react';
import moment from 'moment';
import tinycolor from 'tinycolor2';
// import Markdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';

import Avatar from "@mui/material/Avatar";
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import {formatPatientName} from '../../helpers/patients';
import {formatProviderName} from '../../helpers/providers';
import PatientAvatar from '../patients/PatientAvatar';
import ProviderAvatar from '../providers/ProviderAvatar';
import MarkdownContent from './MarkdownContent';

const MessageAvatar = ({message} = {}) => {
  if (!message || !message?.user_from) return <Avatar size={40} />;
  if (!!message?.user_from?.provider) return <ProviderAvatar provider={message.user_from.provider} />;
  return (
    <PatientAvatar 
      style={{backgroundColor: tinycolor(config().colors.primary).lighten(25).toString()}} 
      patient={message.user_from.patient} 
    />
  );
};

const MessageHeadingText = ({
  message, 
  wasSentByMe = false, 
  onMarkUnread = null,
  markedUnread = false,
}) => (
  <Stack direction='row' spacing={1}>
    <Typography variant='body' sx={{fontWeight: 'bold'}}>
      {
        wasSentByMe
        ? 'You'
        : (
          !!message.user_from.provider
          ? formatProviderName(message.user_from.provider)
          : formatPatientName(message.user_from.patient)
        )
      }
    </Typography>
    <Typography variant='body' color='gray'>
      {moment(message.date_sent).format('h:mm A')}
    </Typography> 
    {
      !wasSentByMe && onMarkUnread && message.is_read && !markedUnread &&
      <Button 
        size='small' 
        variant='text' 
        onClick={e => onMarkUnread(e, message.id)}
        sx={{fontSize: '0.75rem', textTransform: 'none', padding: 0}}
      >
        Mark Unread
      </Button>
    }
  </Stack>
);

const MessageItem = ({
  message,
  wasSentByMe,
  onMarkUnread,
} = {}) => {
  const [markedUnread, setMarkedUnread] = useState(false);
  if (!message || !message?.user_from) return null;
  return (
    <Box mt={1} pl={2}>
      <Stack direction='row' spacing={2}>
        <MessageAvatar message={message} />
        <Stack spacing={0.5}>
          <MessageHeadingText 
            message={message} 
            wasSentByMe={wasSentByMe} 
            onMarkUnread={(e, messageId) => {
              onMarkUnread(messageId);
              setMarkedUnread(true);
            }}
            markedUnread={markedUnread}
          />
          <MarkdownContent html={message.message} />
        </Stack>
      </Stack>
    </Box>
  );
};

export default MessageItem;